<template>
  <div class="popular-box">
    <div class="content" @click="navDetail(popularItem.id)">
      <img :src="popularItem.picUrl">
      <div class="item-name">{{popularItem.name}}</div>
      <!-- <div class="item-advantage">商场优卖点</div> -->
      <div class="item-price">￥{{popularItem.retailPrice}}</div>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["popularItem"],
  methods: {
    navDetail(id) {
      this.$emit("navDetail", id);
    }
  }
};
</script>

<style lang="scss" scoped>
.popular-box {
  width: 100%;
  background: #fff;
  padding-bottom: 1rem;
  box-sizing: border-box;

  .coupon-title {
    width: 100%;
    height: 4rem;
    line-height: 4rem;
    font-size: 1.6rem;
    span {
      float: right;
      margin-right: 1rem;
    }
  }
  .content {
    width: 100%;
    height: 11rem;
    img {
      width: 11rem;
      height: 11rem;
      float: left;
      margin-right: 1.6rem;
      border-radius: 5px;
    }
    .item-name {
      // width: 27rem;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #424242;
      letter-spacing: 0.25px;
      line-height: 1.2rem;
      margin-top: 0.6rem;
    }
    .item-advantage {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      line-height: 1.4rem;
      margin-top: 0.8rem;
      text-align: left;
    }
    .item-price {
      font-family: PingFangSC-Semibold;
      font-size: 1.6rem;
      color: #a9936b;
      letter-spacing: 0;
      line-height: 1.6rem;
      text-align: left;
      margin-top: 2.8rem;
    }
  }
  .line {
    border-bottom: 1px solid #ececec;
    margin-top: 1.55rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popular.vue